export const PROM_HISTOGRAM_ERROR_MESSAGE =
  'Query resulted into raw exponential histograms. Apply an aggregation function (e.g. histogram_quantile) to visualise them.';
